// src/pages/Blogs/BlogService.js
import { BASE_URL } from "../Config";

const API = `${BASE_URL}`;

export const getBlogs = async (page = 1, size = 10, search = "") => {
  const res = await fetch(
    `${API}GetBlogsList?pageNumber=${page}&pageSize=${size}&search=${search}`
  );
  return res.json(); // should return { blogs: [...], total: 100 }
};

export const getBlogById = async (id) => {
  const res = await fetch(`${API}GetBlogbyId?id=${id}`);
  return res.json();
};

export const createBlog = async (formData) => {
  const res = await fetch(`${API}CreateBlog`, {
    method: "POST",
    body: formData,
  });

  return res.json();
};

export const updateBlog = async (formData) => {
  const res = await fetch(`${API}EditBlog`, {
    method: "POST",
    body: formData,
  });

  return res.json();
};